import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { MdsConfig } from '@maersk-global/mds-config';
import { environment } from './environments/environment';
import { enableProdMode } from '@angular/core';

MdsConfig.iconsDynamicImportPath = '/';

function validateEnvironment() {
  const required: [unknown, string][] = [
    [environment.msal.clientId, 'msal.clientId'],
    [environment.msal.authority, 'msal.authority'],
    [environment.api.url, 'api.url'],
    [environment.api.scopes, 'api.scopes'],
  ];

  for (const [value, name] of required) {
    if (!value) throw new Error(`Missing required environment value: ${name}`);
  }
}

validateEnvironment();

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
